import { DomainStoreType } from '@vista-digital/occ-domain'
import { createDomainStore } from '@vista-digital/occ-domain/src/lib/storage/create-domain-store'
import type { Announcement } from '../models/announcement.types'

interface AnnouncementPersistentDomainStore {
    viewed: Record<Announcement['id'], Date>
}

interface AnnouncementSessionDomainStore {
    viewed: Array<Announcement['id']>
}

export const announcementPersistentDomain = createDomainStore<AnnouncementPersistentDomainStore>({
    type: DomainStoreType.BrowserLocal,
    defaultState: { viewed: {} },
    name: 'announcement-persistent-domain-store',
})

export const announcementSessionDomain = createDomainStore<AnnouncementSessionDomainStore>({
    type: DomainStoreType.BrowserSession,
    defaultState: { viewed: [] },
    name: 'announcement-session-domain-store',
})
